
import { defineComponent, ref, computed, onMounted, onUnmounted, reactive } from "vue";
import store from "@/store";
import router from "@/router";
import NativeClient from "@/client/native-client";
import {
  PANTRY_SORT_TYPE,
  PANTRY_FOOD_TYPE,
  PLATE_DELETE_FOOD_STATUS,
  PantrySelectData,
  RequestPantryList,
  PantryListInfo,
  PantryVirtualData,
  FoodItem,
  SearchFoodItem,
  RequestPantrySearch,
  SearchTagItem,
  DeletePantryInfo,
  DetetePantryItem,
  DetetePantryPlateItem,
  DetetePantryFridgeItem,
  RequestFavoriteFood,
  RequestUpdateFoodData,
  RequestUpdateFridgeFoodData,
  UpdatePantryInfo,
  UpdatePantryFridgeInfo,
  RequestShoppingFoods,
  RequestShoppingFood,
  PantryPlateInfoData,
  SEARCH_VIEW_SMALL_HEIGHT_RAITO
} from "@/types/pantry";
import { TagGroupInfo, TagGroups, SearchTag, TagGroup } from "@/types/search";
import PantryListView from "@/components/pantry/PantryListView.vue";
import PantryVirtualView from "@/components/pantry/PantryVirtualView.vue";
import PantrySearchView from "@/components/pantry/PantrySearchView.vue";
import PantryRecipeSearchView from "@/components/pantry/PantryRecipeSearchView.vue";
import PantrySearchDialog from "@/components/pantry/PantrySearchDialog.vue";
import PantrySelectDeleteBar from "@/components/pantry/PantrySelectDeleteBar.vue";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
import { convertRemToPx } from "@/utils/common-utils";
import PantryUtil from "@/utils/pantry-util";
import { COMMON_LIMIT_NUM } from "@/const/limit_const";
import { Recipe } from "@/types/recipes";
export default defineComponent({
  name: "PantryPage",
  components: {
    PantryListView,
    PantryVirtualView,
    PantrySearchView,
    PantryRecipeSearchView,
    PantrySearchDialog,
    PantrySelectDeleteBar,
    CommonDesignDialog,
  },
  setup() {
    /** APIリクエスト時のエラーハンドル */
    NativeClient.sendDebugLog("PantryPage VUE_APP_API_PATH=" + process.env.VUE_APP_API_PATH );
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();
    const SEARCH_VIEW_HIDE_HEIGHT_RAITO = 0;
    const SEARCH_VIEW_LARGE_HEIGHT_RAITO = 0.95;
    const TITLE_HEIGHT_REM = 4.4;
    const ERROR_BUTTON_LABEL = "OK";
    const SWIPE_RECIPE_SEARCH_TIMEOUT_MS = 500;
    const selectPosition = ref(2);
    const isShowFabView = ref(true);

    // 検索画面
    const isShowSearch = ref(false);
    // 検索条件（手入力）
    const isShowFoodSearch = ref(false);
    // 検索詳細ダイアログ
    const isShowPantrySearchDialog = ref(false);
    const searchHeight = ref(SEARCH_VIEW_HIDE_HEIGHT_RAITO);
    const isListSelectMode = ref(false);
    const isShowSelectDeleteBar = ref(false);
    const isShowPlateFoodChange = ref(false);
    const sortType = ref(PANTRY_SORT_TYPE.SHORT_EXPIRED);
    const selectPantryList = ref(Array<PantryVirtualData>());
    const searchFoodList = ref(Array<SearchFoodItem>());
    const tagGroupsInfoList = ref(Array<TagGroupInfo>());
    const searchTagList = ref(Array<SearchTagItem>());
    const backupSearchTagList = ref(Array<SearchTagItem>());
    const pantryList = ref(Array<PantryVirtualData>());
    const pantryVirtualList = ref(Array<PantryVirtualData>());
    const isShowVirtualList = ref(true);
    const isShowList = ref(true);
    const isShowErrorEmpty = ref(false);
    const deleteCompliteMessage = ref("");
    const isShowDeleteComplite = ref(false);
    const isShowCheckValueDelete = ref(false);
    const isShowDeleteFoodCheck = ref(false);
    const selectMessage = ref("");
    const isRefreshEnabled = ref(true);
    let applianceId = "";
    let saveFoodStatus = PLATE_DELETE_FOOD_STATUS.NONE;
    let listTotalCount = 0;
    let virtualTotalCount = 0;
    const deletePantryInfo = ref(new PantryVirtualData(null, null));
    let backUpStockValue = -1;
    const cameraApplianceId = ref("");
    const state = reactive<{ isRequestPantryList: boolean }>({
      // パントリーリスト取得中フラグ
      isRequestPantryList: false
    });
    const recipeSearchList = ref(Array<Recipe>());
    const stateRecipeSearch = reactive<{ isRequestSearch: boolean }>({
      // レシピリスト取得中フラグ
      isRequestSearch: false
    });
    let recipeSearchTotalCount = 0;
    let isSwipeRecipeSearch = false;
    let payloadRecipeSearchData = new RequestPantrySearch(new Array<SearchFoodItem>(), true, ""); 
    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();
    // 表示更新のためのリアクティブ
    const updateKeywordKey = ref(0);
    const updateKeyword = () => {
      if (updateKeywordKey.value >= 100) {
        updateKeywordKey.value = 0;
      } else {
        updateKeywordKey.value++;
      }
    };
    // 表示更新のためのリアクティブ
    const updateListKey = ref(0);
    const updateList = () => {
      if (updateListKey.value >= 100) {
        updateListKey.value = 0;
      } else {
        updateListKey.value++;
      }
    };
    // 表示更新のためのリアクティブ
    const updateDialogKey = ref(0);
    const updateDialog = () => {
      if (updateDialogKey.value >= 100) {
        updateDialogKey.value = 0;
      } else {
        updateDialogKey.value++;
      }
    };
    // 表示更新のためのリアクティブ
    const updateRecipeSearchKey = ref(0);
    const updateRecipeSearch = () => {
      if (updateRecipeSearchKey.value >= 100) {
        updateRecipeSearchKey.value = 0;
      } else {
        updateRecipeSearchKey.value++;
      }
    };
    window.addEventListener('touchmove', function(event) {
      if (NativeClient.isIOS()) {
        event.preventDefault();
      }
    });
    const clearCheckPantyList = () => {
      for (const item of pantryVirtualList.value) {
        item.checked = false;
      }
      for (const item of pantryList.value) {
        item.checked = false;
      }
    };
    const uploadCheckPantryList = () => {
      for (const foodItem of searchFoodList.value) {
        for (const item of pantryVirtualList.value) {
          const equal = item.isEqualsFoodItem(foodItem.food);
          if (equal) {
            item.checked = true;
            break;
          }
        }
        for (const item of pantryList.value) {
          const equal = item.isEqualsFoodItem(foodItem.food);
          if (equal) {
            item.checked = true;
            break;
          }
        }
      }
    };
    const clearSelectMode = () => {
      isListSelectMode.value = false;
      isShowSelectDeleteBar.value = false;
      isShowFabView.value = true;
    };
    const onSelect = (id: number) => {
      selectPosition.value = id;
      if (isShowSelectDeleteBar.value) {
        clearSelectMode();
      }
    };
    const onShowCamera = async () => {
      // 起動前に連携機器のApplianceIdを取得する
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const applianceId = PantryUtil.getCameraApplianceId();
        NativeClient.sendDebugLog(
          "PantryPage onShowCamera applianceId=" + applianceId
        );
        if (applianceId == null || applianceId == "") {
          return;
        }
        NativeClient.transitionPantryCamera();
      });
    };

    const getRecipeSearch = () => {
      const result = store.getters["pantry/getSearchRecipes"];
      NativeClient.sendDebugLog(
        "PantryPage getRecipeSearch result=" + JSON.stringify(result)
      );
      recipeSearchList.value = [];
      recipeSearchTotalCount = 0;
      if (result != null && result.recipes != null) {
        recipeSearchList.value = result.recipes;
        recipeSearchTotalCount = result.totalCount;
      }
      updateRecipeSearch();
    };

    const getRecipeSearchPaging = () => {
      const result = store.getters["pantry/getSearchRecipes"];
      NativeClient.sendDebugLog(
        "PantryPage getRecipeSearchPaging result=" + JSON.stringify(result)
      );
      if (result != null && result.recipes != null) {
        for (const item of result.recipes) {
          recipeSearchList.value.push(item);
        }
      }
    };


    const requestGetSearch = async (payload: RequestPantrySearch) => {
      NativeClient.sendDebugLog(
        "PantryPage requestGetSearch payload=" + JSON.stringify(payload)
      );
      store.dispatch("common/startLoading");
      payloadRecipeSearchData = payload;
      stateRecipeSearch.isRequestSearch = true;
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        Promise.all([store.dispatch("pantry/getSearchRecipes", payload)]).then(
          result => {
            getRecipeSearch();
            stateRecipeSearch.isRequestSearch = false;
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const requestGetSearchPaging = async (payload: RequestPantrySearch) => {
      NativeClient.sendDebugLog(
        "PantryPage requestGetSearchPaging payload=" + JSON.stringify(payload)
      );
      store.dispatch("common/startLoading");
      stateRecipeSearch.isRequestSearch = true;
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        Promise.all([store.dispatch("pantry/getSearchRecipes", payload)]).then(
          result => {
            getRecipeSearchPaging();
            stateRecipeSearch.isRequestSearch = false;
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const onClickSearch = () => {
      clearCheckPantyList();
      uploadCheckPantryList();
      isShowFabView.value = false;
      isShowSearch.value = true;
      searchHeight.value = SEARCH_VIEW_SMALL_HEIGHT_RAITO;
      isListSelectMode.value = true;
      isRefreshEnabled.value =false;
      NativeClient.enablePullToRefresh(false);
      requestGetSearch(new RequestPantrySearch(searchFoodList.value, true, ""));
    };
    const onClickMenu = () => {
      NativeClient.transitionPantryFoodAdd();
    };
    const onShowFoodSearch = () => {
      NativeClient.sendDebugLog("PantryPage onShowFoodSearch");
      updateKeyword();
      isShowFoodSearch.value = true;
    };
    const onFoodSearchClose = () => {
      isShowFoodSearch.value = false;
      store.dispatch("pantry/updateRecipeFoods", null);
    };
    const getTags = () => {
      const tagGroupsInfo: TagGroups | null =
        store.getters["pantry/getTagGroups"];
      NativeClient.sendDebugLog(
        "PantryPage getTags tagGroupsInfo=" + JSON.stringify(tagGroupsInfo)
      );
      const selectTags = searchTagList.value;
      NativeClient.sendDebugLog(
        "PantryPage getTags selectTags=" + JSON.stringify(selectTags)
      );
      let tagsText = "";
      if (tagGroupsInfo != null) {
        tagGroupsInfo.tagGroups.forEach(tagGroups => {
          let tags = "";
          selectTags.forEach(tag => {
            if (tagGroups.alias == tag.alias) {
              if (tags != "") {
                tags += "|";
              }
              tags += tag.id;
            }
          });
          if (tags != "") {
            if (tagsText != "") {
              tagsText += " ";
            }
            if (tagGroups.operation) {
              tagsText += tagGroups.operation + "(" + tags + ")";
            } else {
              tagsText += "OR" + "(" + tags + ")";
            }
          }
        });
      }
      return tagsText;
    };
    const requestRecipeFoods = async (keyword: string) => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        Promise.all([store.dispatch("pantry/getRecipeFoods", keyword)]).then(
          result => {
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const onFoodSearch = (keyword: string) => {
      NativeClient.sendDebugLog("PantryPage onFoodSearch keyword=" + keyword);
      requestRecipeFoods(keyword);
    };

    const requestSearchFood = () => {
      store.dispatch("pantry/updateSearchRecipes", null);
      const tags = getTags();
      NativeClient.sendDebugLog(
        "PantryPage requestSearchFood tags=" + JSON.stringify(tags)
      );
      requestGetSearch(
        new RequestPantrySearch(
          searchFoodList.value,
          true,
          tags
        )
      );
    };

    const onSeachClose = () => {
      backupSearchTagList.value.length = 0;
      if (searchFoodList.value.length != 0) {
        searchFoodList.value = [];
        clearCheckPantyList();
        requestSearchFood();
      }
      isShowSearch.value = false;
      searchHeight.value = SEARCH_VIEW_HIDE_HEIGHT_RAITO;
      clearSelectMode();
      updateDialog();
      isRefreshEnabled.value = true;
      NativeClient.enablePullToRefresh(true);
    };
    const onSelectFood = (food: FoodItem) => {
      onFoodSearchClose();
      if (searchFoodList.value.length == 0) {
        const searchItem = new SearchFoodItem(0, food);
        searchFoodList.value.push(searchItem);
      } else {
        let isEquals = false;
        let id = 0;
        for (const item of searchFoodList.value) {
          if (item.food.name == food.name) {
            isEquals = true;
            break;
          }
          if (id < item.id) {
            id = item.id;
          }
        }
        if (isEquals) {
          NativeClient.sendDebugLog(
            "PantryPage onSelectFood duplication foodItem=" + JSON.stringify(food)
          );
          return;
        }
        const searchItem = new SearchFoodItem(id + 1, food);
        searchFoodList.value.push(searchItem);
      }
      NativeClient.sendDebugLog(
        "PantryPage onSelectFood searchFoodList=" +
          JSON.stringify(searchFoodList.value)
      );
      requestSearchFood();
    };
    const onDeleteFood = (food: FoodItem) => {
      NativeClient.sendDebugLog(
        "PantryPage onDeleteFood food=" + JSON.stringify(food)
      );
      let i = 0;
      for (const item of searchFoodList.value) {
        if (food.timerId == item.food.timerId) {
          break;
        }
        i++;
      }
      for (const item of pantryVirtualList.value) {
        const equal = item.isEqualsFoodItem(food);
        if (equal) {
          NativeClient.sendDebugLog(
            "PantryPage onDeleteFood item=" + JSON.stringify(item)
          );
          item.checked = false;
          break;
        }
      }
      for (const item of pantryList.value) {
        const equal = item.isEqualsFoodItem(food);
        if (equal) {
          item.checked = false;
          break;
        }
      }

      NativeClient.sendDebugLog("PantryPage onDeleteFood i=" + i);
      if (
        searchFoodList.value.length >= 1 &&
        searchFoodList.value.length != i
      ) {
        searchFoodList.value.splice(i, 1);
      }
      store.dispatch("pantry/updateSearchRecipes", null);
      const tags = getTags();
      NativeClient.sendDebugLog(
        "PantryPage onDeleteFood tags=" + JSON.stringify(tags)
      );
      requestGetSearch(
        new RequestPantrySearch(
          searchFoodList.value,
          true,
          tags
        )
      );
      NativeClient.sendDebugLog(
        "PantryPage onDeleteFood list=" + JSON.stringify(searchFoodList.value)
      );
    };
    const setSwipe = () => {
      NativeClient.sendDebugLog("[Paging]PantryPage setSwipe timeStart");
      isSwipeRecipeSearch = true;
      window.setTimeout(() => {
        NativeClient.sendDebugLog("[Paging]PantryPage setSwipe timeOut");
        isSwipeRecipeSearch = false;
      }, SWIPE_RECIPE_SEARCH_TIMEOUT_MS);
    }
    const onSwipeUp = () => {
      NativeClient.sendDebugLog("PantryPage onSwipeUp");
      searchHeight.value = SEARCH_VIEW_LARGE_HEIGHT_RAITO;
      setSwipe();
    };
    const onSwipeDown = () => {
      NativeClient.sendDebugLog("PantryPage onSwipeDown");
      searchHeight.value = SEARCH_VIEW_SMALL_HEIGHT_RAITO;
      setSwipe();
    };
    const onSelectRecipe = (id: number, type: string) => {
      // Native側にレシピ詳細画面に遷移指示を出す
      NativeClient.sendDebugLog(
        "SearchPage selectRecipe id=" + id + " type=" + type
      );
      NativeClient.transitionReceipDetail(id, type);
    };
    const setMultipleSelectTagList = (
      selectedTagList: number[],
      id: number
    ) => {
      if (selectedTagList.includes(id)) {
        const index = selectedTagList.findIndex(
          selectedTag => selectedTag === id
        );
        NativeClient.sendDebugLog(
          "PantryPage setMultipleSelectTagList 1 =" +
            JSON.stringify(selectedTagList)
        );
        selectedTagList.splice(index, 1);
      } else {
        selectedTagList.push(id);
      }
      NativeClient.sendDebugLog(
        "PantryPage setMultipleSelectTagList 2 =" +
          JSON.stringify(selectedTagList)
      );
    };
    const setSingleSelectTagList = (selectedTagList: number[], id: number) => {
      selectedTagList.length = 0;
      selectedTagList.push(id);
      NativeClient.sendDebugLog(
        "PantryPage setSingleSelectTagList 1 =" +
          JSON.stringify(selectedTagList)
      );
    };
    const setSelectTag = (data: SearchTagItem) => {
      for (let i = 0; i < tagGroupsInfoList.value.length; i++) {
        const tagGroupInfo = tagGroupsInfoList.value[i];
        if (tagGroupInfo.tagGroup?.alias == data.alias) {
          if (tagGroupInfo.tagGroup.selectable == 1) {
            setSingleSelectTagList(tagGroupInfo.selected, data.id);
          } else {
            setMultipleSelectTagList(tagGroupInfo.selected, data.id);
          }
        }
      }
    };
    const onSearchDialog = () => {
      backupSearchTagList.value.length = 0;
      for (const item of searchTagList.value) {
        backupSearchTagList.value.push(item);
      }
      isShowPantrySearchDialog.value = true;
    };
    const onSearchDialogClose = () => {
      for (const item of searchTagList.value) {
        setSelectTag(item);
      }
      searchTagList.value.length = 0;
      isShowPantrySearchDialog.value = false;
    };
    const onSearchDialogSetting = (isTargetAll: boolean) => {
      backupSearchTagList.value.length = 0;
      for (const item of searchTagList.value) {
        backupSearchTagList.value.push(item);
        setSelectTag(item);
      }
      isShowPantrySearchDialog.value = false;
      const tags = getTags();
      searchTagList.value.length = 0;
      NativeClient.sendDebugLog(
        "PantryPage onSearchDialogSetting tags=" + JSON.stringify(tags)
      );
      store.dispatch("pantry/updateSearchRecipes", null);
      requestGetSearch(
        new RequestPantrySearch(
          searchFoodList.value,
          isTargetAll,
          tags
        )
      );
    };
    const getSearchViewHeight = () => {
      NativeClient.sendDebugLog("PantryPage getSearchViewHeight innerHeight=" + window.innerHeight);
      let height = 0
      if (searchHeight.value == SEARCH_VIEW_LARGE_HEIGHT_RAITO) {
        height = window.innerHeight - convertRemToPx(TITLE_HEIGHT_REM);
      } else {
        height = window.innerHeight * searchHeight.value;
      }
      return height + "px";
    };

    const clearPantryList = () => {
      pantryList.value = [];
      searchFoodList.value = [];
      listTotalCount = 0;
    };

    const clearPantryVirtualList = () => {
      pantryVirtualList.value = [];
      searchFoodList.value = [];
      virtualTotalCount = 0;
    };

    const getPantryList = () => {
      let result = null
      if (sortType.value == PANTRY_SORT_TYPE.SHORT_EXPIRED){
        result = store.getters["pantry/getPantryVirtualList"];
      } else {
        result = store.getters["pantry/getPantryList"];
      }
      NativeClient.sendDebugLog(
        "PantryPage getPantryList result=" + JSON.stringify(result)
      );

      if (result != null && result.pantryList != null) {
        listTotalCount = result.totalCount;
        for (const item of result.pantryList) {
          pantryList.value.push(new PantryVirtualData(null, item));
        }
      } else {
        listTotalCount = 0;
      }
      isShowList.value = pantryList.value.length != 0;
    };

    const getPantryVirtualList = () => {
      const result = store.getters["pantry/getPantryVirtualList"];
      NativeClient.sendDebugLog(
        "PantryPage pantryList result=" + JSON.stringify(result)
      );

      if (result != null && result.pantryList != null) {
        virtualTotalCount = result.totalCount;
        for (const item of result.pantryList) {
          pantryVirtualList.value.push(new PantryVirtualData(null, item));
        }
      } else {
        virtualTotalCount = 0;
      }
      isShowVirtualList.value = pantryVirtualList.value.length != 0;
    };

    const recipeFoodList = computed(() => {
      const result = store.getters["pantry/getRecipeFoods"];
      NativeClient.sendDebugLog(
        "PantryPage recipeFoodList result=" + JSON.stringify(result)
      );
      if (result != null && result.foods != null) {
        return result.foods;
      }
      return null;
    });

    const isShowCamera = computed(() => {
      return cameraApplianceId.value != "";
    });

    const getSelectsList = (
      searchTags: Array<SearchTag>,
      tagGroup: TagGroup
    ) => {
      const selected = Array<number>();
      if (searchTags != null) {
        searchTags.forEach(e => {
          if (e.alias == tagGroup.alias) {
            tagGroup.tags.forEach(e2 => {
              if (e2.id == e.id) {
                selected.push(e.id);
              }
            });
          }
        });
      }
      return selected;
    };

    const getTagList = () => {
      const result: TagGroups = store.getters["pantry/getTagGroups"];
      NativeClient.sendDebugLog(
        "SearchDetailPage tagGroupsInfo result=" + JSON.stringify(result)
      );
      const searchTags = Array<SearchTag>();
      tagGroupsInfoList.value = [];
      if (result != null) {
        const tagGroupsInfo = Array<TagGroupInfo>();
        for (let i = 0; i < result.tagGroups.length; i++) {
          const tagGroupInfo = new TagGroupInfo(result.tagGroups[i], i);
          tagGroupInfo.selected = getSelectsList(
            searchTags,
            result.tagGroups[i]
          );
          NativeClient.sendDebugLog(
            "PantryPage tagGroupsInfo tagGroupInfo=" +
              JSON.stringify(tagGroupInfo)
          );
          tagGroupsInfo.push(tagGroupInfo);
        }
        NativeClient.sendDebugLog(
          "PantryPage tagGroupsInfo tagGroupsInfo=" +
            JSON.stringify(tagGroupsInfo)
        );
        tagGroupsInfoList.value = tagGroupsInfo;
      }
    };

    const requestPagingPantryList = async (start: number) => {
            store.dispatch("common/startLoading");
      const payload = new RequestPantryList(sortType.value, start, COMMON_LIMIT_NUM.PANTRY_LIST_ITEM_PAGING_LIMIT);
      NativeClient.sendDebugLog("[Paging]PantryPage requestPagingPantryList payload=" + JSON.stringify(payload));
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        cameraApplianceId.value = PantryUtil.getCameraApplianceId();
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        state.isRequestPantryList = true;
        if (sortType.value == PANTRY_SORT_TYPE.SHORT_EXPIRED) {
          // 消費期限目安が短い順の場合、Virtualのソート条件の結果を参照
          Promise.all([
            store.dispatch("pantry/getPantryVirtualList", payload),
          ]).then(result => {
            getPantryList();
            getPantryVirtualList();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        } else {
          Promise.all([
            store.dispatch("pantry/getPantryList", payload),
          ]).then(result => {
            getPantryList();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        }
      });
    };

    const requestPagingPantryVirtual = async (start: number) => {
            store.dispatch("common/startLoading");
      const payload = new RequestPantryList(sortType.value, start, COMMON_LIMIT_NUM.PANTRY_LIST_ITEM_PAGING_LIMIT);
      NativeClient.sendDebugLog("[Paging]PantryPage requestPagingPantryVirtual payload=" + JSON.stringify(payload));
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        cameraApplianceId.value = PantryUtil.getCameraApplianceId();
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        state.isRequestPantryList = true;
        if (sortType.value == PANTRY_SORT_TYPE.SHORT_EXPIRED) {
          // 消費期限目安が短い順の場合、Virtualのソート条件の結果を参照
          Promise.all([
            store.dispatch("pantry/getPantryVirtualList", payload),
          ]).then(result => {
            getPantryList();
            getPantryVirtualList();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        } else {
          Promise.all([
            store.dispatch("pantry/getPantryVirtualList", payload),
          ]).then(result => {
            getPantryVirtualList();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        }
      });
    };

    const requestGetPantry = async () => {
      store.dispatch("common/startLoading");
      const payload = new RequestPantryList(sortType.value, 0, COMMON_LIMIT_NUM.PANTRY_LIST_ITEM_FIRST_LIMIT);
      NativeClient.sendDebugLog("[Paging]PantryPage requestGetPantry payload=" + JSON.stringify(payload));
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        cameraApplianceId.value = PantryUtil.getCameraApplianceId();
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        state.isRequestPantryList = true;
        if (sortType.value == PANTRY_SORT_TYPE.SHORT_EXPIRED) {
          // 消費期限目安が短い順の場合、Virtualのソート条件の結果を参照
          Promise.all([
            store.dispatch("pantry/getPantryVirtualList", payload),
            store.dispatch("pantry/getTagGroups"),
          ]).then(result => {
            getPantryList();
            getPantryVirtualList();
            getTagList();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        } else {
          Promise.all([
            store.dispatch("pantry/getPantryList", payload),
            store.dispatch("pantry/getPantryVirtualList", payload),
            store.dispatch("pantry/getTagGroups"),
          ]).then(result => {
            getPantryList();
            getPantryVirtualList();
            getTagList();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        }
      });
    };

    const requestGetPantryList = async () => {
      store.dispatch("common/startLoading");
      const payload = new RequestPantryList(sortType.value, 0, COMMON_LIMIT_NUM.PANTRY_LIST_ITEM_FIRST_LIMIT);
      NativeClient.sendDebugLog("[Paging]PantryPage requestGetPantryList payload=" + JSON.stringify(payload));
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        state.isRequestPantryList = true;
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        if (sortType.value == PANTRY_SORT_TYPE.SHORT_EXPIRED) {
          Promise.all([
            store.dispatch("pantry/getPantryVirtualList", payload)
          ]).then(result => {
            clearPantryList();
            clearPantryVirtualList();
            getPantryList();
            getPantryVirtualList();
            requestSearchFood();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        } else {
          Promise.all([
            store.dispatch("pantry/getPantryList", payload),
            store.dispatch("pantry/getPantryVirtualList", payload)
          ]).then(result => {
            clearPantryList();
            clearPantryVirtualList();
            getPantryList();
            getPantryVirtualList();
            requestSearchFood();
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          });
        }
      });
    };

    const updatePantryList = () => {
      NativeClient.sendDebugLog("PantryPage updatePantryList");
      store.dispatch("pantry/updatePantryList", null);
      store.dispatch("pantry/updatePantryVirtualList", null);
      selectPantryList.value = [];
      pantryList.value = [];
      pantryVirtualList.value = [];
      searchFoodList.value = [];
      // 画面切り替え通知
      requestGetPantryList();
    };
    NativeClient.updatePantryList(updatePantryList);
    /*
     * レシピ詳細の取得を実行する
     */
    const execute = async () => {
      requestGetPantry();
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      // 画面から離れた場合
    });

    const clickListSelectMode = () => {
      selectPantryList.value.length = 0;
      if (selectPosition.value == 0 && !isShowSearch.value) {
        // リスト表示中は、削除項目を表示
        isShowSelectDeleteBar.value = !isListSelectMode.value;
        if (isShowSelectDeleteBar.value) {
          // 削除項目表示中は、FABアイコン非表示
          isShowFabView.value = false;
          clearCheckPantyList();
        }
      }
      isListSelectMode.value = !isListSelectMode.value;
      if (!isShowSelectDeleteBar.value) {
        // 削除項目非表示のタイミングで、FABアイコン表示
        isShowFabView.value = true;
        clearCheckPantyList();
        isRefreshEnabled.value = true;
        NativeClient.enablePullToRefresh(true);
      } else {
        isRefreshEnabled.value = false;
        NativeClient.enablePullToRefresh(false);
      }
    };

    const requestDeletePantry = async (foodStatus: number | null) => {
      store.dispatch("common/startLoading");
      NativeClient.sendDebugLog(
        "PantryPage requestDeletePantry payload=" +
          JSON.stringify(selectPantryList.value)
      );
      const payload = new DeletePantryInfo();
      selectPantryList.value.forEach(item => {
        if (item.info) {
          if (item.info.pantryId != null) {
            payload.pantryList.push(
              new DetetePantryItem(item.info.pantryId, foodStatus)
            );
          } else if (item.info.pantryPlateId != null) {
            payload.pantryPlateList.push(
              new DetetePantryPlateItem(item.info.pantryPlateId, foodStatus)
            );
          } else if (item.info.pantryFridgeId != null) {
            payload.pantryFridgeList.push(
              new DetetePantryFridgeItem(item.info.pantryFridgeId, foodStatus)
            );
          }
        }
      });
      NativeClient.sendDebugLog(
        "PantryPage requestDeletePantry payload=" + JSON.stringify(payload)
      );
      if (
        payload.pantryList.length == 0 &&
        payload.pantryPlateList.length == 0 &&
        payload.pantryFridgeList.length == 0
      ) {
        store.dispatch("common/stopLoading");
        isShowErrorEmpty.value = true;
        NativeClient.sendDebugLog(
          "PantryPage requestDeletePantry empty"
        );
        return;
      }
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        state.isRequestPantryList = true;
        Promise.all([store.dispatch("pantry/deletePantry", payload)]).then(
          result => {
            NativeClient.sendDebugLog(
              "PantryPage requestDeletePantry result"
            );
            store.dispatch("common/stopLoading");
            NativeClient.requestUpdatePantryListFoodManagement();
            if (foodStatus == null) {
              deleteCompliteMessage.value = "リストから削除しました";
            } else if (foodStatus == PLATE_DELETE_FOOD_STATUS.THREW_AWAY) {
              deleteCompliteMessage.value = "ごめんなさい";
            } else if (foodStatus == PLATE_DELETE_FOOD_STATUS.USED) {
              deleteCompliteMessage.value = "ごちそうさまでした";
            }
            isShowDeleteComplite.value = true;
            store.dispatch("common/stopLoading");
            state.isRequestPantryList = false;
          }
        );
      });
    };

    const clickSelectDeleteItem = (foodStatus: number) => {
      NativeClient.sendDebugLog(
        "PantryPage clickSelectDeleteItem foodStatus=" + foodStatus
      );
      saveFoodStatus = foodStatus;
      isShowDeleteFoodCheck.value = true;
    };

    const selectSortType = (type: string) => {
      NativeClient.sendDebugLog("PantryPage selectSortType type=" + type);
      if (sortType.value == type) {
        return;
      }
      sortType.value = type;
      store.dispatch("pantry/updatePantryList", null);
      store.dispatch("pantry/updatePantryVirtualList", null);
      clearPantryList();
      clearPantryVirtualList();
      requestGetPantry();
    };

    const onSelectListItemCheck = (
      data: PantryVirtualData,
      checked: boolean
    ) => {
      NativeClient.sendDebugLog(
        "PantryPage onSelectListItemCheck checked=" +
          checked +
          " data=" +
          JSON.stringify(data)
      );
      if (data == null || data.info == null) {
        return;
      }
      if (
        data.info.pantryId == null &&
        data.info.pantryPlateId == null &&
        data.info.pantryFridgeId == null
      ) {
        return;
      }
      for (const item of pantryVirtualList.value) {
        const equal = item.isEquals(data.info);
        if (equal) {
          item.checked = checked;
          break;
        }
      }
      for (const item of pantryList.value) {
        const equal = item.isEquals(data.info);
        if (equal) {
          item.checked = checked;
          break;
        }
      }
      if (isShowSearch.value) {
        if (checked) {
          let id = 0;
          for (const item of searchFoodList.value) {
            if (id < item.id) {
              id = item.id;
            }
          }
          const foodItem = new FoodItem(data.info.name, data.info.imageUrl, data.info.ingredientId, null);
          foodItem.pantryId = data.info.pantryId;
          foodItem.pantryPlateId = data.info.pantryPlateId;
          foodItem.pantryFridgeId = data.info.pantryFridgeId;
          const item = new SearchFoodItem(id + 1, foodItem);
          searchFoodList.value.push(item);
        } else {
          let i = 0;
          let tag = -1;
          for (const info of searchFoodList.value) {
            if (info.food != null && info.food.isEqual(data)) {
              tag = i;
              break;
            }
            i++;
          }
          if (tag != -1) {
            searchFoodList.value.splice(i, 1);
          }
        }
        NativeClient.sendDebugLog(
          "PantryPage onSelectListItemCheck isShowSearch searchFoodList=" +
            JSON.stringify(searchFoodList.value)
        );
        requestSearchFood();
      } else {
        let i = 0;
        let tag = -1;
        for (const info of selectPantryList.value) {
          if (info.isEquals(data.info)) {
            tag = i;
            break;
          }
          i++;
        }
        if (checked) {
          selectPantryList.value.push(data);
        } else {
          if (tag != -1) {
            selectPantryList.value.splice(i, 1);
          }
        }
        NativeClient.sendDebugLog(
          "PantryPage onSelectListItemCheck selectPantryList=" +
            JSON.stringify(selectPantryList.value)
        );
      }
    };

    const onSelectTag = (alias: string, id: number) => {
      const data = new SearchTagItem(alias, id);
      NativeClient.sendDebugLog(
        "PantryPage onSelectTag item=" + JSON.stringify(data)
      );
      setSelectTag(data);
      if (searchTagList.value.length == 0) {
        searchTagList.value.push(data);
      } else {
        let i = 0;
        for (const item of searchTagList.value) {
          if (item.alias == data.alias && item.id == data.id) {
            break;
          }
          i++;
        }
        if (i == searchTagList.value.length) {
          searchTagList.value.push(data);
        } else {
          searchTagList.value.splice(i, 1);
        }
      }
    };

    const showPantryDetail = (data: PantryListInfo) => {
      NativeClient.sendDebugLog(
        "PantryPage showPantryDetail data=" + JSON.stringify(data)
      );
      let id = "";
      let type = "";
      let plateValue = "";
      if (data.pantryId != null) {
        id = "" + data.pantryId;
        type = PANTRY_FOOD_TYPE.USER;
      } else if (data.pantryPlateId != null) {
        id = "" + data.pantryPlateId;
        if (data.plate != null) {
          plateValue = "" + PantryUtil.getPlateValuePlateInfo(new PantryPlateInfoData(data.plate));
        }
        type = PANTRY_FOOD_TYPE.PLATE;
      } else if (data.pantryFridgeId != null) {
        id = "" + data.pantryFridgeId;
        type = PANTRY_FOOD_TYPE.FRIDGE;
      }
      NativeClient.sendDebugLog(
        "PantryPage showPantryDetail id=" + JSON.stringify(id) + " type=" + type + " plateValue=" + plateValue
      );
      if (id == "" && data.plate != null) {
        applianceId = (data.applianceId) ? data.applianceId : "";
        isShowPlateFoodChange.value = true;
        return;
      }
      NativeClient.transitionPantryDetail(id, type, plateValue);
      // router.push("pantry-detail?applianceId=" + "V2XCAbNUUvYeN4ADg2LsEQ8IDSpn88t9cB4s01w0j0M=&push=1");
    };
    const onSelectVirtualPantry = (data: PantryVirtualData, checked: boolean) => {
      if (isShowSearch.value) {
        onSelectListItemCheck(data, checked);
        return;
      }
      if (data.info) {
        showPantryDetail(data.info);
      }
    };
    const onSelectListPantry = (data: PantryVirtualData) => {
      NativeClient.sendDebugLog(
        "PantryPage onSelectListPantry data=" + JSON.stringify(data)
      );
      if (isShowSearch.value || isListSelectMode.value) {
        return;
      }
      if (data.info) {
        showPantryDetail(data.info);
      }
    };
    const updateFavorite = (info: PantryListInfo, favoriteStatus: boolean) => {
      for (const item of pantryList.value) {
        if (item && item.info) {
          if (item.info.pantryId && item.info.pantryId == info.pantryId
            || item.info.pantryPlateId && item.info.pantryPlateId == info.pantryPlateId
            || item.info.pantryFridgeId && item.info.pantryFridgeId == info.pantryFridgeId) {
            item.info.favoriteStatus = favoriteStatus;
            break;
          }
        }
      }
    };
    const requnstFavorite = async (info: PantryListInfo) => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const webApiList = new Array<any>();
        const payload = new RequestFavoriteFood(info.ingredientId);
        const favoriteStatus = !info.favoriteStatus;
        if (favoriteStatus) {
          webApiList.push(store.dispatch("pantry/addFavoriteFood", payload));
        } else {
          webApiList.push(store.dispatch("pantry/removeFavoriteFood", payload));
        }
        Promise.all(webApiList).then(
          result => {
            updateFavorite(info, favoriteStatus);
            NativeClient.requestReloadFavoriteFood();
            store.dispatch("common/stopLoading");
          }
        );
      });
    };
    const onClickFavorite = (data: PantryVirtualData) => {
      NativeClient.sendDebugLog(
        "PantryPage onClickFavorite data=" + JSON.stringify(data)
      );
      if (isShowSearch.value || isListSelectMode.value) {
        return;
      }
      if (data.info && data.info.ingredientId) {
        requnstFavorite(data.info);
      }
    };
    const requestShoppingIngredients = async (shoppingFoods: RequestShoppingFoods) => {
      store.dispatch("common/startLoading");
      const apiBaseParams = store.getters["common/getApiBaseParams"];
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/registerShoppingFoods", shoppingFoods)]).then(
          result => {
            store.dispatch("common/stopLoading");
          }
        );
      });
    };
    const onClickAddShoppingList = (data: PantryVirtualData) => {
      NativeClient.sendDebugLog(
        "PantryPage onClickAddShoppingList data=" + JSON.stringify(data)
      );
      if (isShowSearch.value || isListSelectMode.value) {
        return;
      }
      if (data.info == null) {
        return;
      }
      const shoppingFood = new RequestShoppingFood(data.info.ingredientId, data.info.name);
      const shoppingFoods = new RequestShoppingFoods();
      shoppingFoods.foods.push(shoppingFood);
      requestShoppingIngredients(shoppingFoods);
    };
    const onClickShowShoppingList = () => {
      NativeClient.sendDebugLog(
        "PantryPage onClickShowShoppingList"
      );
      NativeClient.transitionShoppingList();
    };
    const updateValue = (info: PantryListInfo, value: number) => {
      for (const item of pantryList.value) {
        if (
          (item.info) && (
            (item.info.pantryId && item.info.pantryId == info.pantryId) ||
            (item.info.pantryFridgeId && item.info.pantryFridgeId == info.pantryFridgeId)
          )
        ) {
          NativeClient.sendDebugLog("PantryPage updateValue value=" + value);
          info.stockQuantity = value;
          item.info.stockQuantity = value;
          break;
        }
      }
      if (value == 0) {
        const name = info != null ? info.name : "";
        selectMessage.value = name + "\nを使い切りましたか?";
        isShowCheckValueDelete.value = true;
        deletePantryInfo.value.info = info;
        updateList();
      } else {
        deletePantryInfo.value.info = null;
        backUpStockValue = -1;
      }
    };
    const requestUpdateValue = async (info: PantryListInfo, value: number, isUpdateList: boolean) => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const webApiList = new Array<any>();
        if (info.pantryId) {
          const request = new UpdatePantryInfo();
          request.set(info.purchaseDate, info.expirationDate, info.notificationDate, info.storageType, value);
          const payload = new RequestUpdateFoodData(info.pantryId, request);
          webApiList.push(store.dispatch("pantry/updatePantry", payload));
        } else if (info.pantryFridgeId) {
          const request = new UpdatePantryFridgeInfo();
          request.set(info.purchaseDate, info.expirationDate, info.notificationDate, value);
          const payload = new RequestUpdateFridgeFoodData(info.pantryFridgeId, request);
          webApiList.push(store.dispatch("pantry/updateFridgePantry", payload));
        }
        Promise.all(webApiList).then(
          result => {
            updateValue(info, value);
            if (isUpdateList) {
              updateList();
            }
            store.dispatch("common/stopLoading");
          }
        );
      });
    };
    const changeValue = (data: PantryVirtualData, value: number, isUpdateList: boolean) => {
      NativeClient.sendDebugLog(
        "PantryPage changeValue value=" + value +" data=" + JSON.stringify(data)
      );
      if (isShowSearch.value || isListSelectMode.value) {
        return;
      }
      if (data.info && (data.info.pantryId || data.info.pantryFridgeId)) {
        // 変更前の情報を保持
        const stockValue = PantryUtil.getStockValue(data);
        NativeClient.sendDebugLog("[AAA]PantryPage changeValue stockValue=" + stockValue);
        backUpStockValue = stockValue;
        requestUpdateValue(data.info, value, isUpdateList);
      }
    };
    const onClickPlateFoodChangeNegative = () => {
      isShowPlateFoodChange.value = false;
    };
    const onClickPlateFoodChangePositive = () => {
      isShowPlateFoodChange.value = false;
      // レスポンスが追加されるまで暫定対応
      NativeClient.changePlateFoodReset(applianceId);
    };
    const onClickErrorEmpty = () => {
      isShowErrorEmpty.value = false;
    };
    const onClickDeleteComplite = () => {
      // Apiのレスポンスで画面更新するとレスポンス後の処理が無視されるため、タイミングを変更
      // 選択状態解除
      clearSelectMode();
      clearCheckPantyList();
      isShowDeleteComplite.value = false;
      isRefreshEnabled.value = true;
      NativeClient.enablePullToRefresh(true);
      updatePantryList();
    };
    const requestDelete = async (foodStatus: number) => {
      NativeClient.sendDebugLog("PantryPage requestDelete info=" + JSON.stringify(deletePantryInfo.value.info));
      if (deletePantryInfo.value.info == null) {
        NativeClient.sendDebugLog("PantryPage requestDelete info empty");
        return;
      }
      store.dispatch("common/startLoading");
      const payload = new DeletePantryInfo();
      if (deletePantryInfo.value.info.pantryId) {
        payload.pantryList.push(new DetetePantryItem(deletePantryInfo.value.info.pantryId, foodStatus));
      } else if (deletePantryInfo.value.info.pantryPlateId) {
        payload.pantryPlateList.push(new DetetePantryPlateItem(deletePantryInfo.value.info.pantryPlateId, foodStatus));
      } else if (deletePantryInfo.value.info.pantryFridgeId) {
        payload.pantryFridgeList.push(new DetetePantryFridgeItem(deletePantryInfo.value.info.pantryFridgeId, foodStatus));
      }
      NativeClient.sendDebugLog("PantryPage requestDeletePantry payload=" + JSON.stringify(payload));
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        state.isRequestPantryList = true;
        Promise.all([
          store.dispatch("pantry/deletePantry", payload),
        ]).then(result => {
          NativeClient.sendDebugLog(
            "PantryPage requestDeletePantry result"
          );
          deletePantryInfo.value.info = null;
          deleteCompliteMessage.value = "食材が消費されました";
          isShowDeleteComplite.value = true;
          store.dispatch("common/stopLoading");
          state.isRequestPantryList = false;
          NativeClient.requestUpdatePantryListFoodManagement();
        });
      });
    };
    const onClickValueDeleteNegative = () => {
      isShowCheckValueDelete.value = false;
      requestDelete(PLATE_DELETE_FOOD_STATUS.THREW_AWAY);
    };
    const onClickValueDeletePositive = () => {
      isShowCheckValueDelete.value = false;
      requestDelete(PLATE_DELETE_FOOD_STATUS.USED);
    };
    const onClickValueDeleteClose = () => {
      isShowCheckValueDelete.value = false;
      NativeClient.sendDebugLog("[AAA]PantryPage onClickValueDeleteClose info=" + JSON.stringify(deletePantryInfo.value.info));
      if (deletePantryInfo.value.info == null || backUpStockValue == -1) {
        NativeClient.sendDebugLog("[AAA]PantryPage onClickValueDeleteClose info empty");
        return;
      }
      NativeClient.sendDebugLog("[AAA]PantryPage onClickValueDeleteClose backUpStockValue=" + backUpStockValue);
      changeValue(deletePantryInfo.value, backUpStockValue, true)
    };
    const onClickDeleteFoodCheckNegative = () => {
      isShowDeleteFoodCheck.value = false;
      saveFoodStatus = PLATE_DELETE_FOOD_STATUS.NONE;
    };
    const onClickDeleteFoodCheckPositive = () => {
      isShowDeleteFoodCheck.value = false;
      if (saveFoodStatus == PLATE_DELETE_FOOD_STATUS.NONE) {
        requestDeletePantry(null);
      } else {
        requestDeletePantry(saveFoodStatus);
      }
      saveFoodStatus = PLATE_DELETE_FOOD_STATUS.NONE;
    };
    const refreshList = () => {
      NativeClient.sendDebugLog("PantryPage refreshList");
      updatePantryList();
    };
    const refreshVirtual = () => {
      NativeClient.sendDebugLog("PantryPage refreshVirtual");
      updatePantryList();
    };
    const styleHeaderBackground = computed(() => {
      if (selectPosition.value == 2) {
        return { background: `none` };
      } else {
        return { background: `#ffffff` };
      }
    });
    const closeError = () => {
      closeDialog();
      NativeClient.showCameraCloseButton(true);
    };
    const isExecScrollEnd = () => {
       NativeClient.sendDebugLog(
        "[Paging]PantryPage isExecScrollEnd isShowSearch=" + isShowSearch.value + 
        " selectMode=" + isListSelectMode.value + 
        " isRequestPantryList=" + state.isRequestPantryList
      );
      return !isShowSearch.value && !isListSelectMode.value && !state.isRequestPantryList;
    }
    const onScrollEndList = () => {
      NativeClient.sendDebugLog("PantryPage onScrollEndList");
      const exec = isExecScrollEnd();
      const listCount = pantryList.value.length;
      NativeClient.sendDebugLog(
        "[Paging]PantryPage onScrollEndList listCount=" + listCount +
        " totalCount=" + virtualTotalCount +
        " exec=" + exec
      );
      if (exec && listCount < listTotalCount) {
        NativeClient.sendDebugLog("[PagingPantryPage onScrollEndList exec");
        state.isRequestPantryList = true;
        requestPagingPantryList(listCount);
      }
    };
    const onScrollEndVirtual = () => {
      NativeClient.sendDebugLog("PantryPage onScrollEndVirtual");
      const exec = isExecScrollEnd();
      const listCount = pantryVirtualList.value.length;
      NativeClient.sendDebugLog(
        "[Paging]PantryPage onScrollEndVirtual listCount=" + listCount +
        " totalCount=" + virtualTotalCount +
        " exec=" + exec
      );
      if (exec && listCount < virtualTotalCount) {
        NativeClient.sendDebugLog("[PagingPantryPage onScrollEndVirtual exec"); 
        state.isRequestPantryList = true;
        requestPagingPantryVirtual(listCount);
      }
    };
    const isExecScrollEndRecipeSearch = () => {
       NativeClient.sendDebugLog(
        "[Paging]PantryPage isExecScrollEndRecipeSearch isShowSearch=" + isShowSearch.value + 
        " isSwipeRecipeSearch=" + isSwipeRecipeSearch + 
        " isRequestSearch=" + stateRecipeSearch.isRequestSearch
      );
      return isShowSearch.value && !isSwipeRecipeSearch && !stateRecipeSearch.isRequestSearch;
    }
    const onScrollEndRecipeSearch = () => {
      NativeClient.sendDebugLog("PantryPage onScrollEndRecipeSearch");
      const exec = isExecScrollEndRecipeSearch();
      const listCount = recipeSearchList.value.length;
      NativeClient.sendDebugLog(
        "[Paging]PantryPage onScrollEndRecipeSearch listCount=" + listCount +
        " totalCount=" + recipeSearchTotalCount +
        " exec=" + exec
      );
      if (exec && listCount < recipeSearchTotalCount) {
        NativeClient.sendDebugLog("[Paging]PantryPage onScrollEndRecipeSearch exec"); 
        // レシピ検索追加読み込み
        payloadRecipeSearchData.set(
          listCount,
          COMMON_LIMIT_NUM.PANTRY_LIST_RECIPE_SEARCH_ITEM_PAGING_LIMIT);
        requestGetSearchPaging(payloadRecipeSearchData);
      }
    }
    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      closeDialog,
      selectPosition,
      onSelect,
      onShowCamera,
      isShowFabView,
      isShowSearch,
      onClickSearch,
      onClickMenu,
      onSeachClose,
      onShowFoodSearch,
      onSwipeUp,
      onSwipeDown,
      getSearchViewHeight,
      pantryList,
      pantryVirtualList,
      isListSelectMode,
      clickListSelectMode,
      selectSortType,
      sortType,
      onSelectListItemCheck,
      isShowFoodSearch,
      onFoodSearchClose,
      onFoodSearch,
      recipeFoodList,
      onSelectFood,
      searchFoodList,
      onDeleteFood,
      onSelectRecipe,
      onSelectVirtualPantry,
      onSelectListPantry,
      onSearchDialog,
      isShowPantrySearchDialog,
      onSearchDialogClose,
      onSelectTag,
      onSearchDialogSetting,
      isShowSelectDeleteBar,
      clickSelectDeleteItem,
      onClickFavorite,
      onClickAddShoppingList,
      onClickShowShoppingList,
      getPantryList,
      changeValue,
      isShowPlateFoodChange,
      onClickPlateFoodChangeNegative,
      onClickPlateFoodChangePositive,
      isShowErrorEmpty,
      onClickErrorEmpty,
      isShowDeleteComplite,
      deleteCompliteMessage,
      onClickDeleteComplite,
      isShowCheckValueDelete,
      selectMessage,
      onClickValueDeleteNegative,
      onClickValueDeletePositive,
      onClickValueDeleteClose,
      tagGroupsInfoList,
      isShowDeleteFoodCheck,
      onClickDeleteFoodCheckNegative,
      onClickDeleteFoodCheckPositive,
      updateKeywordKey,
      isShowVirtualList,
      isShowList,
      updateListKey,
      updateDialogKey,
      refreshList,
      refreshVirtual,
      isRefreshEnabled,
      styleHeaderBackground,
      isShowCamera,
      closeError,
      ERROR_BUTTON_LABEL,
      onScrollEndList,
      onScrollEndVirtual,
      recipeSearchList,
      updateRecipeSearchKey,
      onScrollEndRecipeSearch
    };
  }
});
